export const FEATURES_MAP = {
  noRental: {
    title: 'No Rental Available',
    description: 'Please check rental availability at a nearby location',
    icon: 'bigtruck.svg',
    path: '/rentals'
  },
  onlyTools: {
    title: 'Rental Center',
    description: 'Rent top quality tools for any size project',
    icon: 'drill-gray.svg',
    path: '/rentals'
  },
  onlyTrucks: {
    title: 'Rental Center',
    description: 'Rent trucks to get the job done',
    icon: 'bigtruck.svg',
    path: '/rentals'
  },
  onlyMoving: {
    title: 'Rental Center',
    description: 'Rent box trucks to help with your move',
    icon: 'boxtruck-gray.svg',
    path: '/rentals'
  },
  rentalCenter: {
    title: 'Rental Center',
    description: 'Rent top quality tools, equipment and trucks for any size project',
    icon: 'bigtruck.svg',
    path: '/rentals'
  },
  onlyRugDoctor: { // TODO: Need data in the BE
    title: 'Rental Center',
    description: 'Clean floors in as little as 20 minutes with the RugDoctor Pro',
    icon: 'boxtruck-gray.svg',
    path: '/rentals'
  },
  onlyElectricTool: { // TODO: Need data in the BE
    title: 'Rental Center',
    description: 'Rent top quality electric power tools from our most trusted brands',
    icon: 'drill-gray.svg',
    path: '/rentals'
  },
  garden: {
    title: 'Garden Center',
    description: 'Visit the garden center for plants, garden tools and more',
    icon: 'gardencenter.svg',
    path: '/garden-center'
  },
  home: {
    title: 'Home Services',
    description: 'Certified, local experts to build your dream home',
    icon: 'getinstalled.svg',
    path: '/services'
  },
  storeLayout: {
    title: 'Store Layout',
    description: 'Find where product lives by aisles in the store',
    icon: 'storelayout.svg',
    path: 'storemap'
  },
  pro: {
    title: 'Pro Desk',
    description: 'Get pro savings, place custom orders, save time and money',
    icon: 'pro-icon.svg',
    path: '/pro-desk'
  },
  default: {
    title: 'Rental Center',
    description: 'Rent top quality tools, equipment and trucks for any size project',
    icon: 'bigtruck.svg',
    path: '/rentals'
  },
};

const getAltServiceDescription = (storeServices = {}, serviceType) => {
  const {
    toolRental = false,
    penske = false,
    loadNGo = false,
    rugDoctor = false,
    largeEquipment = false,
    hdMoving = false
  } = storeServices;

  if (serviceType === 'onlyTrucks') {
    const truckServices = {
      flatbedTruck: {
        active: (penske && loadNGo && !hdMoving),
        description: 'Rent flatbed pickup and moving trucks to get the job done.',
      },
      onlyLoadNGo: {
        active: (!penske && loadNGo && !hdMoving),
        description: 'Rent flatbed pickup trucks and vans to help with your project',
      },
      flatbedOrBoxTruck: {
        active: (!penske && loadNGo && hdMoving),
        description: 'Rent flatbed pickup or box trucks for your project needs',
      }
    };
    const activeService = Object.keys(truckServices).find((i) => truckServices[i].active === true);
    return truckServices[activeService].description;
  }
  const rentalServices = {
    toolFlatbedTrucksAndLargeEq: {
      active: (toolRental && penske && loadNGo && !rugDoctor && largeEquipment && !hdMoving),
      description: 'Rent top quality tools, equipment and trucks for any size project',
    },
    toolLoadAndGoAndLargeEq: {
      active: (toolRental && !penske && loadNGo && !rugDoctor && largeEquipment && !hdMoving),
      description: 'Rent the tools, trucks and equipment to get the job done',
    },
    toolAndFlatbedTrucks: {
      active: (toolRental && penske && loadNGo && !rugDoctor && !largeEquipment && !hdMoving),
      description: 'Rent top quality tools and trucks for any size project',
    },
    toolTrucksAndLargeEq: {
      active: (toolRental && !penske && loadNGo && !rugDoctor && largeEquipment && hdMoving),
      description: 'Rent top quality tools and trucks for any size project',
    },
    truckHeavyTools: {
      active: (!toolRental && !penske && loadNGo && !rugDoctor && largeEquipment && hdMoving),
      description: 'Rent the tools, trucks or heavy equipment to get the job done',
    },
    electricAndHeavyTools: {
      active: (!toolRental && !penske && !loadNGo && !rugDoctor && largeEquipment && !hdMoving),
      description: 'Rent electric power tools and pro grade heavy equipment from our most trusted brands',
    }
  };

  const activeService = Object.keys(rentalServices).find((key) => rentalServices[key].active === true);
  if (!activeService) {
    return FEATURES_MAP.rentalCenter.description;
  }
  return rentalServices[activeService].description;

};

export const getRentalService = (storeServices) => {
  if (!storeServices) return FEATURES_MAP.noRental;

  const {
    toolRental = false,
    penske = false,
    loadNGo = false,
    toolRentalLite = false,
    rugDoctor = false,
    largeEquipment = false,
    hdMoving = false
  } = storeServices;

  const rentalServices = {
    onlyMoving: ((penske || hdMoving)
      && !largeEquipment && !loadNGo && !rugDoctor && !toolRental && !toolRentalLite),
    onlyRugDoctor: (rugDoctor
      && !hdMoving && !largeEquipment && !loadNGo && !penske && !toolRental && !toolRentalLite),
    onlyTools: (toolRental && !toolRentalLite
      && !hdMoving && !largeEquipment && !loadNGo && !penske && !rugDoctor),
    onlyTrucks: ((loadNGo || penske || hdMoving)
      && !largeEquipment && !rugDoctor && !toolRental && !toolRentalLite),
    onlyElectricTool: (toolRentalLite && !toolRental
      && !hdMoving && !largeEquipment && !loadNGo && !penske && !rugDoctor),
    rentalCenter: (!rugDoctor && (toolRentalLite || toolRental
      || hdMoving || largeEquipment || loadNGo || penske))
  };
  const activeService = Object.keys(rentalServices).find((key) => rentalServices[key] === true);
  if (!activeService) {
    return FEATURES_MAP.noRental;
  }
  if (activeService === 'onlyTrucks' || activeService === 'rentalCenter') {
    FEATURES_MAP[activeService].description = getAltServiceDescription(storeServices, activeService);
  }
  return FEATURES_MAP[activeService];

};
